import type { TypedDocumentNode } from "@graphql-typed-document-node/core"
import { mockMap } from "./context"

export const registerMockData = <TData, TVariables>(
  query: TypedDocumentNode<TData, TVariables>,
  data: TData
) => {
  mockMap.set(query, data)
}
